module.exports = __webpack_public_path__ + "img/icon-game.ca9a73c2.svg";